export const getStyles = ({ isFeatured, companyIndex, variant }) => ({
	layoutWrapper: `tw:block tw:mb-5 tw:bg-white tw:rounded-lg tw:overflow-hidden tw:shadow-[0px_1px_2px_0px_rgba(88,102,126,0.12),0px_4px_24px_0px_rgba(88,102,126,0.06)] ${isFeatured ? "tw:mt-8 tw:border-2 tw:border-solid tw:border-[#9e79e8]" : ""}`,
	featuredCompanyHeader: {
		wrapper: "tw:p-2 tw:bg-[#faf5ff] tw:text-center",
		contentWrapper:
			"tw:leading-6 tw:font-semibold tw:text-xs tw:tracking-[-0.00875rem] tw:xs:text-sm tw:lg:text-base tw:lg:tracking-[-0.01rem]",
	},
	coupon: {
		wrapper: "tw:p-2 tw:bg-white tw:flex tw:items-center tw:justify-center",
		contentWrapper:
			"tw:w-full tw:p-2 tw:flex tw:items-center tw:justify-center tw:text-center tw:bg-[#fdeef2] tw:text-[#e1255b] tw:rounded-lg tw:hover:underline",
		contentIcon: "tw:inline-flex tw:mr-2 tw:text-2xl tw:text-[#E1255B]",
		content: "tw:text-sm tw:sm:text-base tw:font-bold",
	},
	rootGrid:
		"tw:flex tw:flex-col tw:lg:flex-row tw:min-h-[250px] tw:justify-center tw:items-center tw:lg:items-stretch tw:py-2",
	col1: "tw:w-full tw:lg:w-[30%] tw:max-w-none tw:flex tw:flex-col tw:justify-center tw:relative",
	col2: "tw:w-[90%] tw:lg:w-[48%] tw:max-w-none tw:flex tw:flex-col tw:justify-center tw:items-start tw:px-0 tw:lg:px-2 tw:my-2 tw:lg:my-0",
	col3: "tw:w-full tw:lg:w-[22%] tw:max-w-none tw:flex tw:flex-wrap tw:flex-col tw:pb-2 tw:justify-center tw:xs:pb-0 tw:xs:flex-row tw:xs:justify-evenly tw:lg:flex-col tw:lg:justify-center tw:items-center",
	logoWrapper: "tw:pt-16 tw:pb-4 tw:px-0 tw:lg:py-0",
	companyLogo: {
		picture: "tw:flex tw:justify-center",
		image:
			"tw:max-w-[230px] tw:lg:max-w-[220px] tw:my-2 tw:lg:my-0 tw:rounded-lg",
	},
	serviceFlag: {
		wrapper: "",
		flag: "tw:ml-2 tw:absolute tw:top-1 tw:lg:top-[45%] tw:bg-[#616096] tw:w-[28px] tw:h-[28px] tw:text-white tw:font-extrabold tw:flex tw:justify-center tw:items-center tw:shadow-lightShadow tw:rounded-full",
		number: "tw:m-0 tw:text-white tw:font-medium tw:text-sm",
		text: "tw:bg-[#359492] tw:top-1 tw:w-max tw:absolute tw:text-white tw:h-[28px] tw:flex tw:justify-center tw:items-center tw:my-0 tw:py-0 tw:pl-2 tw:pr-5 tw:font-medium tw:text-sm tw:shadow-lightShadow tw:ml-10 tw:lg:ml-0 tw:[clip-path:polygon(100%_0,calc(100%-10px)_50%,100%_100%,0_100%,0_0)]",
	},
	productDescription: {
		text: "tw:text-lg tw:font-bold tw:mb-2 tw:text-[#000a25]",
	},
	companyBadge: {
		wrapper:
			"tw:flex tw:bg-[#00b679] tw:justify-center tw:items-center tw:p-1 tw:mb-2 tw:rounded-sm tw:shadow-lightShadow",
		text: "tw:text-white tw:font-semibold tw:text-xs tw:mb-0 tw:mx-1",
	},
	benefitsList: {
		wrapper: "tw:w-full tw:px-0",
		list: "tw:w-full tw:mb-0 tw:p-0",
		listItem:
			"tw:w-full tw:text-sm tw:text-[#000a25] tw:pl-6 tw:mb-2 tw:bg-[url(/public/react-images/common/favyCheck.svg)] tw:bg-position-[left_top_7px] tw:bg-no-repeat",
	},
	visitLink: {
		wrapper:
			"tw:my-2 tw:mx-0 tw:flex tw:w-[250px] tw:text-pretty tw:min-h-[48px] tw:bg-[#359492] tw:rounded-lg tw:shadow-lightShadow tw:cursor-pointer tw:transition tw:hover:bg-[#3d9f9e] tw:hover:shadow-[0px_2px_4px_0px_#c0c0c0] tw:lg:w-[196px]",
		contentWrapper:
			"tw:px-2 tw:py-3 tw:text-white tw:w-full tw:flex tw:items-center tw:justify-center tw:text-center tw:font-semibold tw:text-base",
	},
	reviewLink: {
		wrapper: `tw:mt-2 tw:xs:mt-0 tw:lg:mt-5 ${companyIndex === 0 ? "tw:mt-2 tw:xs:mt-[70px] tw:lg:mt-4" : ""}`,
		text: "tw:text-[#359492] tw:hover:underline tw:text-base tw:font-semibold",
	},
	socialProofSection:
		"tw:shrink tw:lg:shrink-0 tw:grow tw:lg:grow-0 tw:mb-0 tw:mt-4 tw:lg:mt-0 tw:basis-full tw:lg:basis-0",
	socialProof: {
		wrapper:
			"tw:relative tw:flex tw:max-w-fit tw:self-center tw:rounded-lg tw:mx-auto tw:mb-4 tw:bg-white tw:p-2 tw:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:after:absolute tw:after:right-[calc(50%-6px)] tw:after:w-2.5 tw:after:h-2.5 tw:after:translate-x-0 tw:after:-translate-y-2/4 tw:after:rotate-45 tw:after:bg-white tw:after:overflow-hidden tw:after:pointer-events-none tw:md:after:w-3 tw:md:after:h-3 tw:after:top-full",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: `${variant && companyIndex === 0 ? "tw:text-[#E1255B]" : "tw:text-[#616096]"} tw:text-2xl tw:md:text-[32px]`,
		content:
			"tw:min-w-[100px] tw:max-w-[100px] tw:font-semibold tw:text-[0.6875rem] tw:m-0! tw:text-left tw:text-[#22293A]",
	},
	rating: {
		wrapper: "tw:flex tw:mb-2",
		score:
			"tw:font-extrabold tw:text-[#1a1a1a] tw:text-xl tw:mb-0 tw:mr-4 tw:lg:mr-2",
		stars:
			"tw:flex tw:justify-between tw:lg:justify-center tw:flex-row tw:items-center tw:mr-4 tw:lg:mr-2 tw:w-fit",
		starColor: "tw:text-[#00b679]",
		starSize: "tw:text-base",
		count:
			"tw:text-sm tw:font-semibold tw:text-[#1a1a1a] tw:mb-0 tw:tracking-tight tw:text-center tw:ml-2",
	},
});
